var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestMoreInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127.808,
    height: 119.778,
    viewBox: "0 0 127.808 119.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7248",
    "data-name": "Rectangle 7248",
    width: 127.808,
    height: 119.778,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68433",
    "data-name": "Group 68433",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68432",
    "data-name": "Group 68432",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44590",
    "data-name": "Path 44590",
    d: "M42.639,28.486A1.642,1.642,0,1,1,41,30.128a1.642,1.642,0,0,1,1.642-1.642",
    transform: "translate(21.384 14.859)",
    fill: "#fce17c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44591",
    "data-name": "Path 44591",
    d: "M33.682,1.405A35.974,35.974,0,0,0,7.359,57.134L1.444,70.448a2,2,0,0,0,2.638,2.632l13.31-5.916A35.983,35.983,0,1,0,33.682,1.405",
    transform: "translate(0.665 0.637)",
    fill: "#3ebded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44592",
    "data-name": "Path 44592",
    d: "M72.871,40.21a42,42,0,0,0-21.3,20.207,4.109,4.109,0,0,1-3.3,2.331,33.529,33.529,0,0,1-10.243-.641A35.88,35.88,0,0,1,16.173,5.771a35.9,35.9,0,0,0-8.813,49l-5.914,13.3A2,2,0,0,0,4.083,70.71L17.393,64.8a35.884,35.884,0,0,0,23.545,5.849,34.263,34.263,0,0,0,7.521-1.624c.2-.067,1.407-.493,1.8-.648v-.014a36.135,36.135,0,0,0,22.61-28.15",
    transform: "translate(0.664 3.011)",
    fill: "#00a2d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44593",
    "data-name": "Path 44593",
    d: "M75.051,30.352a35.974,35.974,0,0,1,26.324,55.729l5.916,13.31a2,2,0,0,1-2.638,2.638l-13.31-5.916A35.984,35.984,0,1,1,75.051,30.352",
    transform: "translate(18.477 15.736)",
    fill: "#eceaec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44594",
    "data-name": "Path 44594",
    d: "M92.448,89.333a35.931,35.931,0,0,1-42.089-54.7A35.982,35.982,0,0,0,91.305,93.787l13.31,5.916a1.978,1.978,0,0,0,2.494-.768L96.394,90a3.938,3.938,0,0,0-3.946-.671",
    transform: "translate(18.503 18.063)",
    fill: "#dad8db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44595",
    "data-name": "Path 44595",
    d: "M47.389,70.661a33.386,33.386,0,0,1-6.036,1.163A33.839,33.839,0,0,1,19.03,66.28a1.872,1.872,0,0,0-1.8-.152L3.922,72.042a.126.126,0,0,1-.167-.167L9.67,58.565a1.876,1.876,0,0,0-.152-1.8A34.109,34.109,0,1,1,71.855,41.339a1.873,1.873,0,0,0,3.726.365A37.86,37.86,0,1,0,5.836,57.97L.334,70.353a3.868,3.868,0,0,0,5.111,5.111l12.383-5.5a37.882,37.882,0,0,0,30.6,4.3,1.872,1.872,0,0,0-1.044-3.6Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44596",
    "data-name": "Path 44596",
    d: "M45.55,23.665H25.559a1.872,1.872,0,1,0,0,3.745H45.55a1.872,1.872,0,0,0,0-3.745",
    transform: "translate(12.355 12.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44597",
    "data-name": "Path 44597",
    d: "M25.559,20.838h14a1.872,1.872,0,1,0,0-3.745h-14a1.872,1.872,0,0,0,0,3.745",
    transform: "translate(12.355 8.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44598",
    "data-name": "Path 44598",
    d: "M45.55,30.233H25.559a1.872,1.872,0,1,0,0,3.745H45.55a1.872,1.872,0,0,0,0-3.745",
    transform: "translate(12.355 15.77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44599",
    "data-name": "Path 44599",
    d: "M109.651,99.264l-5.5-12.384A37.877,37.877,0,1,0,92.159,98.868l12.383,5.5a3.873,3.873,0,0,0,5.111-5.111Zm-3.448,1.662a.1.1,0,0,1-.142.026l-13.31-5.915a1.876,1.876,0,0,0-1.8.152,34.137,34.137,0,1,1,9.512-9.513,1.872,1.872,0,0,0-.152,1.8l5.916,13.31a.1.1,0,0,1-.024.14l0,0Z",
    transform: "translate(17.822 15.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44600",
    "data-name": "Path 44600",
    d: "M89.243,52.568H45.269a1.872,1.872,0,0,0,0,3.745H89.243a1.872,1.872,0,0,0,0-3.745",
    transform: "translate(22.636 27.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44601",
    "data-name": "Path 44601",
    d: "M49.207,49.743H81.192a1.872,1.872,0,0,0,0-3.745H49.207a1.872,1.872,0,0,0,0,3.745",
    transform: "translate(24.69 23.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44602",
    "data-name": "Path 44602",
    d: "M81.192,59.137H49.207a1.872,1.872,0,0,0,0,3.745H81.192a1.872,1.872,0,0,0,0-3.745",
    transform: "translate(24.69 30.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44603",
    "data-name": "Path 44603",
    d: "M26.164,23.555a7.871,7.871,0,0,0-15.615,1.411,1.872,1.872,0,1,0,3.745,0,4.129,4.129,0,0,1,4.131-4.128,4.066,4.066,0,0,1,.756.07A4.18,4.18,0,0,1,22.475,24.2a4.125,4.125,0,0,1-3.013,4.755,3.776,3.776,0,0,0-2.917,3.652v.353a1.872,1.872,0,0,0,3.745,0v-.326a.31.31,0,0,1,.117-.056,7.844,7.844,0,0,0,5.756-9.025",
    transform: "translate(5.502 8.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44604",
    "data-name": "Path 44604",
    d: "M16.382,30.233h-.02a1.881,1.881,0,1,0,.02,0",
    transform: "translate(7.559 15.77)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestMoreInformation);
export default __webpack_public_path__ + "static/media/request_more_information.0078eec6d42ab142925a36480e02b19a.svg";
export { ForwardRef as ReactComponent };